import { IstitutiHero } from "@/components/istituti/IstitutiHero";
import { Bussola } from "@/components/istituti/Bussola";
import { Esperienze } from "@/components/istituti/Esperienze";
import { Burocrazia } from "@/components/istituti/Burocrazia";
import { PercheIstituti } from "@/components/istituti/PercheIstituti";
import { UniscitiCta } from "@/components/istituti/UniscitiCta";

export default function Istituti() {
  return (
    <main data-testid="istituti-page">
      <IstitutiHero />
      <Bussola />
      <Esperienze />
      <Burocrazia />
      <PercheIstituti />
      <UniscitiCta />
    </main>
  );
}
